import React from 'react'
import Drawer from "react-drag-drawer";
import { playSong } from '../../utils/song'
import songsName from '../../enums/songsName'
import { FiX } from 'react-icons/fi';
import LogoPng from '../../assets/images/new/dum-dum-logo.png'
import { BsArrowLeftCircle } from 'react-icons/bs';

const AboutModal = (props) => {
  const closeHandler = () => {
    playSong(songsName.TAP)
    props.close()
  }

  return (
    <Drawer
      dontApplyListeners={true}
      allowClose={false}
      open={props.isOpened}
      onRequestClose={props.close}
      direction="left"
      modalElementClass="absolute top-0 left-0"
    >
      <div
        className={`w-screen max-w-lg h-screen bg-modal flex flex-col justify-start items-start px-4 pb-4 text-lg overflow-y-auto`}
        style={{
          paddingTop: window.native_app_status_bar_height ?? 16,
          paddingBottom: window.native_app_navigation_bar_height ?? 16
        }}
      >
        <div className='w-full flex flex-row justify-between items-center'>
          <div className='w-full flex flex-row justify-between items-center'>
            <div
              className='flex flex-row justify-start items-center cursor-pointer'
              onMouseEnter={() => {
                playSong(songsName.TAP)
              }}
              onClick={() => {
                playSong(songsName.TAP)

                props.backToDrawerMenu()
              }}
            >
              <BsArrowLeftCircle className="w-8 h-8 text-blue-primary" />
            </div>

            <img src={LogoPng} className='w-40 h-12 mx-auto' alt='Logo' />

            <button
              type="button"
              onMouseEnter={() => {
                playSong(songsName.TAP)
              }}
              onClick={closeHandler}
              className={`text-black bg-transparent hover:bg-slate-200 rounded-lg text-2xl lg:text-xl`}
            >
              <FiX className="w-8 h-8 text-blue-primary" />
            </button>
          </div>
        </div>

        <h2 className='text-blue-primary font-bold text-xl text-center mx-auto my-8'>Sobre nós</h2>

        <p className='text-lg mb-2'>
          Somos o dum dum livros! Trazemos diretamente da TV para as páginas dos livros os personagens que você conhece e os valores que você compartilha: amizade, empatia e respeito. A inclusão é uma de nossas principais pautas.
        </p>

        <p className='text-lg'>
          Unimos entretenimento e educação para que as crianças até 10 anos adquiram o hábito e o gosto pela leitura. Selecionamos com todo o cuidado os livros que vão fazer parte da primeira biblioteca dos pequenos leitores, para que eles se divirtam e aprendam que a leitura pode ser tão prazerosa quanto qualquer outra forma de entretenimento. 
        </p>
      </div>
    </Drawer>
  )
}

export default AboutModal